module.exports = __webpack_public_path__ + "img/chasa_yes.374266be.png";